import { render, staticRenderFns } from "./ShortlistCatalogs.vue?vue&type=template&id=f62e48fc&"
import script from "./ShortlistCatalogs.vue?vue&type=script&lang=js&"
export * from "./ShortlistCatalogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports